// 秒杀详情页
export default {
  routes: [
    {
      path: '/selectSaleType',
      name: 'selectSaleType',
      meta: {
        title: '选择卖法',
        desc: '选择卖法',
        pageId: 'Y2053'
      },
      component: () =>
        import(/* webpackChunkName: "selectSaleType" */ '../views/selectSaleType/index.vue')
    },
    {
      path: '/saleTypeIntroduce',
      name: 'saleTypeIntroduce',
      meta: {
        title: '了解卖法',
        desc: '了解卖法',
        pageId: 'M1352'
      },
      component: () =>
        import(
          /* webpackChunkName: "saleTypeIntroduce" */ '../views/selectSaleType/saleTypeIntroduce.vue'
        )
    }
  ]
}
